import Swal from "sweetalert2";

const YthBusiness = (() => {
    $("#publisherId").select2();
    let lastResponse = '';
    let buttonId = '';
    let BusinessListingDT = null;
    let publisherId = "";

    BusinessListingDT =
        $('#business_dt').DataTable({
            responsive: true,
            processing: true,
            serverSide: true,
            // ordering: false,
            searching: true,
            order: [[11, 'desc']],
            // "sProcessing": "Please wait...",
            "language": {
                "processing": '<i class="myspinner fa fa-spinner fa-spin" style="font-size:24px;color:rgb(75, 183, 245);"></i>'
            },
            // "pagingType": "full_numbers",
            pageLength: 25,
            ajax: {
                url: '/businesses/listing',
                type: 'POST',
                data: function (data) {
                    data.publisherId = publisherId;
                },
            },
            columns: [
                { data: 'checkbox', name: 'checkbox', className: "align-middle", },
                { data: 'business_company', name: 'businesses.company' },
                { data: 'gcid', name: 'gcid.gcid_name' },
                { data: 'email', name: 'email', visible: false },
                { data: 'address', name: 'address', sortable: false, visible: false },
                { data: 'phone', name: 'phone', visible: false },
                { data: 'address2', name: 'address2', visible: false },
                { data: 'city', name: 'city', visible: false },
                { data: 'state', name: 'state', visible: false },
                { data: 'zip_code', name: 'zip_code', visible: false },
                { data: 'listing_type', name: 'listing_type' },
                { data: 'updated_at', name: 'businesses.updated_at' },
                {
                    data: 'action',
                    name: 'action',
                    className: "text-end"
                },
            ],
            columnDefs: [{
                orderable: false,
                className: 'select-checkbox',
                targets: 0
            }],
            select: {
                style: 'os',
                selector: 'td:first-child'
            }
        });
    $("#publisherId").on("select2:select", function (e) {
        publisherId = $(this).val();
        BusinessListingDT.draw();
    });

    if ($('#business_dt').length > 0) {
        localStorage.setItem('current_tab', '');
    }
    $(document).on('click', '#download_tld', function (event) {
        var bIds = new Array();
        $("input[name='tld_ids[]']:checked:enabled").each(function () {
            bIds.push($(this).val());
        });

        var query = {
            bids: bIds
        }
        if (bIds.length > 0) {
            var url = baseUrl + "/business/export-tld?id=&" + $.param(query);
            window.location = url;
        }
        else {
            Swal.fire("Please select atleast one business", '', 'error');
        }

    });

    $(document).on('click', '#generate_report', function (event) {
        var bIds = new Array();
        $("input[name='tld_ids[]']:checked:enabled").each(function () {
            bIds.push($(this).val());
        });

        var query = {
            bids: bIds
        }
        if (bIds.length > 0) {
            var url = baseUrl + "/business/generate_report?id=&" + $.param(query);
            window.location = url;
        }
        else {
            Swal.fire("Please select atleast one business", '', 'error');
        }

    });

    $(document).on('change', '#listing_type', function (event) {
        var typeValue = $("#listing_type").val();
        if (typeValue == 'trusted') {
            $("#trustred_tou").show();
        }
        else {
            $("#trustred_tou").hide();
        }
    });


    $(document).on('click', '.removeImage', function (event) {
        const imageId = $(event.currentTarget).data('imageid');
        var imagekey = $(event.currentTarget).data('imagekey');
        $.ajax({
            type: "POST",
            // data: {_method: 'delete'},
            url: baseUrl + "/business/delete-image/" + imageId,
            success: function (data) {
                $(".preview_image_section_" + imagekey).empty();
            },
            error: function (data) {
                Swal.fire('Problem to delete image', '', 'error');
            }
        });


    });

    function copyToClipboard(text) {
        var dummy = document.createElement("textarea");
        // to avoid breaking orgain page when copying more words
        // cant copy when adding below this code
        // dummy.style.display = 'none'
        document.body.appendChild(dummy);
        //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
        dummy.value = text;
        dummy.select();
        document.execCommand("copy");
        document.body.removeChild(dummy);
    }

    $(document).on('click', '.clipboard', function (event) {
        const clipboard = $(event.currentTarget).data('clipboard');
        copyToClipboard(clipboard);

    });

    $(document).on('click', '.select-all', function (event) {
        event.preventDefault();
        let selector = $(this).attr('data-selector');
        $("." + selector + " > option").prop("selected", true);
        $("." + selector).trigger("change");
        $(this).siblings('.deselect-all').removeClass('hidden');
        $(this).addClass('hidden');

    });

    $(document).on('click', '.deselect-all', function (event) {
        event.preventDefault();
        let selector = $(this).attr('data-selector');
        $("." + selector + " > option").prop("selected", false);
        $("." + selector).trigger("change");
        $(this).siblings('.select-all').removeClass('hidden');
        $(this).addClass('hidden');
    });

    //delete options
    $(document).on('click', '.delete-business', function (event) {
        const id = $(event.currentTarget).data('id');
        var option_id = $(this).data("id");

        Swal.fire({
            icon: 'error',
            title: 'Do you want to delete?',
            showCancelButton: true,
            confirmButtonText: 'Delete',
            denyButtonText: `Cancel`,
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    type: "POST",
                    data: { _method: 'delete' },
                    url: baseUrl + "/businesses/" + id,
                    success: function (data) {
                        var oTable = $('#business_dt').dataTable();
                        oTable.fnDraw(false);
                        Swal.fire(data.message, '', 'success').then(function () {
                            window.location = baseUrl + "/businesses";
                        });;
                    },
                    error: function (data) {
                        Swal.fire(data.responseJSON.message, '', 'error');
                    }
                });

            } else if (result.isDenied) {
                Swal.fire('Changes are not saved', '', 'info')
            }
        });
    });
    //heading_datatable
    // $('#heading_datatable').DataTable({
    //     responsive: true,
    //     processing: true,
    //     serverSide: true,
    //     ordering: true,
    //     searching: true,
    //     pageLength: 10,
    //     ajax: {
    //         url : '/all-headings',
    //         type : 'POST'
    //     },
    //     columns: [
    //         {data: 'heading_name', name: 'heading_name'},
    //     ],
    //     drawCallback: function () {
    //           $("#heading_datatable .draggable_td").draggable({
    //           helper: function(){
    //             var selected = $('td.selectedCell');
    //             if (selected.length === 0) {
    //               selected = $(this).addClass('selectedCell');
    //             }
    //             var container = $('<div/>').attr('id', 'draggingContainer');
    //             container.append(selected.clone().removeClass("selectedCell"));
    //             return container;
    //             }
    //           });
    //         }
    // });
    //
    $(".select2_show").select2({
        placeholder: 'Select or enter new copy points',
        tags: true,
        multiple: true,
    });

    $(".select2_additional_show").select2({
        placeholder: 'Select Additional keywords',
        tags: true,
        multiple: true,
    });

    //  $("#heading_select2").select2({
    //      placeholder: 'Select or add an item',
    //     tags: true,
    //     multiple:true,
    //     createTag: function (params) {
    //         return null;
    //       },
    //  });

    $('#heading_select2').select2({
        placeholder: "Select or add an item",
        //tags: true,
        multiple: true,
        // tokenSeparators: [",", " "],
        // createSearchChoice: function (term, data) {
        //     if ($(data).filter(function () {
        //         return this.text.localeCompare(term) === 0;
        //     }).length === 0) {
        //         return {
        //             id: term,
        //             text: term
        //         };
        //     }
        // },
        ajax: {
            url: baseUrl + "/business/heading",
            dataType: 'json',
            type: "GET",
            quietMillis: 50,
            data: function (params) {
                return {
                    term: params.term,
                    page: params.current_page
                };
            },
            processResults: function (data, params) {
                params.current_page = data.current_page + 1;
                return {
                    results: $.map(data.data, function (item) {
                        let textValue = (item.sub_headings_count > 0) ? item.heading_name + "(" + item.sub_headings_count + ")" : item.heading_name;
                        return {
                            text: textValue,
                            id: item.id,
                            gcid_name: item.gcid_name,
                        }
                    }),
                    pagination: {
                        more: data.last_page > data.current_page
                    }
                };
            },
        }
    });

    $("#hours_selected2").select2({
        placeholder: 'Select or add an item',
        tags: true,
        multiple: true
    });
    $("#payment_selected2").select2({
        placeholder: 'Select or add an item',
        tags: true,
        multiple: true
    });

    // $('#heading_select2').select2({
    // multiple: true,
    // minimumInputLength: 3,
    // placeholder: 'Select an item',
    // tags: false,
    // minimumInputLength: 2,
    // ajax: {
    //     url: '/all-headings',
    //     dataType: 'json',
    //     delay: 250,
    //     processResults: function (data) {
    //       return {
    //         results:  $.map(data, function (item) {
    //               return {
    //                   text: item.name,
    //                   id: item.id
    //               }
    //           })
    //       };
    //     },
    //     cache: true
    //   }
    // });



    $(document).on('change', '.images', function (event) {
        let preview = $(this).data('preview');
        $('#' + preview).removeClass('d-none');
        $('#' + preview).attr('src', window.URL.createObjectURL(this.files[0]));

    });

    $(document).on('click', '#quickSave', function (e) {
        e.preventDefault();
        $('.quick-save-val').val(1);
        if ($('#heading_select2').find(':selected').val()) {
            $('#stepForm').trigger("submit")
            $('.heading-error').hide();
        } else {
            $('.heading-error').show();
        }
    });

    $(document).ready(function () {
        $('#wave').hide();
    })

    $(document).on('click', '#submitQuestion', function (e) {
        e.preventDefault();
        $.ajax({
            url: $('#ChatForm').attr('action'),
            data: {
                'chat-question': $('#chatQuestion').val(),
                '_token': $('input[name=_token]').val()
            },
            type: 'POST',
            beforeSend: function () {
                $('.chatModalBody').append('<div class="text-end">' + $('#chatQuestion').val() + '</div>');
                $('#chatQuestion').val('')
                $('#wave').show();
            },
            complete: function () {
                $('#wave').hide();
            },
            success: function (data) {
                let html = '<div class="text-left chat-response">' + data + '</div>';
                lastResponse = data;
                $('.chatModalBody').append(html)
            }
        })
    });

    $(document).on('click', '#descHelp', function () {
        let name = $('input[name=company]').val();
        let city = $('input[name=city]').val();
        let state = $('input[name=state]').val();
        $.ajax({
            url: $('#ChatForm').data('short-description-url'),
            data: {
                'name': name,
                'city': city,
                'state': state,
                '_token': $('input[name=_token]').val()
            },
            type: 'POST',
            beforeSend: function () {
                $('.chatModalBody').append('<div class="text-end">' + name + ',' + city + ',' + state + '</div>');
                $('#chatQuestion').val('')
                $('#wave').show();
            },
            complete: function () {
                $('#wave').hide();
            },
            success: function (data) {
                let html = '<div class="text-left chat-response">' + data + '</div>';
                lastResponse = data;
                $('.chatModalBody').append(html)
            }
        })
    })

    $(document).on('click', '#longDescHelp', function () {
        let name = $('input[name=company]').val();
        let city = $('input[name=city]').val();
        let state = $('input[name=state]').val();
        $.ajax({
            url: $('#ChatForm').data('long-description-url'),
            data: {
                'name': name,
                'city': city,
                'state': state,
                '_token': $('input[name=_token]').val()
            },
            type: 'POST',
            beforeSend: function () {
                $('.chatModalBody').append('<div class="text-end">' + name + ',' + city + ',' + state + '</div>');
                $('#chatQuestion').val('')
                $('#wave').show();
            },
            complete: function () {
                $('#wave').hide();
            },
            success: function (data) {
                let html = '<div class="text-left chat-response">' + data + '</div>';
                lastResponse = data;
                $('.chatModalBody').append(html)
            }
        })
    })

    $('#ChatModal').on('hidden.bs.modal', function () {
        $('.chatModalBody').html('')
    })

    $('#ChatModal').on('shown.bs.modal', function (e) {
        buttonId = e.relatedTarget.id;
    });

    $('#copyClipboard').on('click', function () {
        if (buttonId == 'descHelp') {
            $('.' + buttonId).val(lastResponse.substr(0, 250));
        } else {
            $('.' + buttonId).val(lastResponse);
        }
    });

    // $('#checkBox').on('click',function(){
    //     if($(this).is(':checked')){

    //     }else{

    //     }
    // });
    $("#checkBox").click(function () {
        $('input:checkbox').not(this).prop('checked', this.checked);
    });

    $(document).on('click', '.job-error', function () {
        let job_error = $(this).data('content');
        Swal.fire("Business not submitted to Listings Engine", 'Reason ' + job_error.data, 'error');
    });

    const ADVICE_LOCAL_MIN_DESC = 100;
    const ADVICE_LOCAL_MAX_DESC = 250;

    function updateAdviceLocalCounter() {
        const $desc = $('#description');
        if (!$desc.length) return;
        const len = $desc.val().length;
        $('#dcount').text(len);
        $('#dremaining').text(Math.max(0, ADVICE_LOCAL_MIN_DESC - len));
        $('#advice_local_process_btn').prop('disabled', len < ADVICE_LOCAL_MIN_DESC);
        if (len >= ADVICE_LOCAL_MIN_DESC) {
            $('.description-error').hide();
        }
    }

    function resetAdviceLocalModal() {
        $('#adviceLocalFormBody').hide().empty();
        $('#adviceLocalAlert').hide().empty();
        $('#adviceLocalLoader').show();
        $('#advice_local_process_btn').prop('disabled', true);
    }

    $(document).on('click', '.publish-advice-local', function () {
        const slug = $(this).data('slug');
        if (!slug) return;
        resetAdviceLocalModal();
        const modalEl = document.getElementById('adviceLocalModal');
        const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
        modal.show();

        $.ajax({
            url: baseUrl + '/business/publish-advice-local/' + encodeURIComponent(slug),
            type: 'GET',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            success: function (html) {
                $('#adviceLocalLoader').hide();
                $('#adviceLocalFormBody').html(html).show();
                updateAdviceLocalCounter();
            },
            error: function (xhr) {
                $('#adviceLocalLoader').hide();
                const msg = (xhr.responseJSON && xhr.responseJSON.message)
                    ? xhr.responseJSON.message
                    : 'Unable to load the form. Please try again.';
                $('#adviceLocalAlert').text(msg).show();
            }
        });
    });

    $(document).on('click', '.assign-sales', function () {
        const slug = $(this).data('slug');
        if (!slug) return;
        const assigned = ($(this).data('assigned') || []).map(String);

        $('#assignSalesForm').data('slug', slug);

        const $select = $('#assignSalesSelect');
        if ($select.length) {
            if ($select.hasClass('select2-hidden-accessible')) {
                $select.select2('destroy');
            }
            $select.val(assigned);
            $select.select2({
                dropdownParent: $('#assignSalesModal'),
                width: '100%',
                placeholder: 'Select sales users'
            });
        }

        bootstrap.Modal.getOrCreateInstance(document.getElementById('assignSalesModal')).show();
    });

    $(document).on('submit', '#assignSalesForm', function (e) {
        e.preventDefault();
        const $form = $(this);
        const slug = $form.data('slug');
        if (!slug) return;
        const $btn = $form.find('button[type="submit"]');
        $btn.prop('disabled', true);

        $.ajax({
            url: baseUrl + '/business/assign-sales/' + encodeURIComponent(slug),
            type: 'POST',
            data: $form.serialize(),
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            success: function (res) {
                bootstrap.Modal.getOrCreateInstance(document.getElementById('assignSalesModal')).hide();
                if (BusinessListingDT) BusinessListingDT.ajax.reload(null, false);
                Swal.fire((res && res.message) ? res.message : 'Sales assignments updated.', '', 'success');
            },
            error: function (xhr) {
                const msg = (xhr.responseJSON && xhr.responseJSON.message)
                    ? xhr.responseJSON.message
                    : 'Something went wrong. Please try again.';
                Swal.fire(msg, '', 'error');
            },
            complete: function () {
                $btn.prop('disabled', false);
            }
        });
    });

    $(document).on('input', '#description', updateAdviceLocalCounter);

    $('#adviceLocalModal').on('hidden.bs.modal', function () {
        resetAdviceLocalModal();
        if (BusinessListingDT) BusinessListingDT.ajax.reload(null, false);
    });

    $(document).on('submit', '#advice_local_form', function (e) {
        e.preventDefault();
        const $form = $(this);
        const $btn = $('#advice_local_process_btn');
        const $alert = $('#adviceLocalAlert').hide().empty();

        $('.company-error, .phone-error, .description-error').hide();

        if (!$('#company').val()) { $('.company-error').show(); return; }
        if (!$('#phone').val()) { $('.phone-error').show(); return; }

        const descLen = ($('#description').val() || '').length;
        if (descLen < ADVICE_LOCAL_MIN_DESC) { $('.description-error').show(); return; }

        $btn.prop('disabled', true).text('Saving...');

        $.ajax({
            url: $form.attr('action'),
            type: 'POST',
            data: $form.serialize(),
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            success: function (res) {
                bootstrap.Modal.getOrCreateInstance(document.getElementById('adviceLocalModal')).hide();
                Swal.fire(res.message || 'Submitted.', '', 'success');
            },
            error: function (xhr) {
                $btn.prop('disabled', false).text('Save');
                const res = xhr.responseJSON || {};
                if (xhr.status === 422 && res.errors) {
                    const messages = Object.values(res.errors).flat().join(' ');
                    $alert.text(messages).show();
                    return;
                }
                const msg = res.message || 'Something went wrong. Please try again.';
                $alert.text(msg).show();
            },
            complete: function () {
                updateAdviceLocalCounter();
                if ($btn.text() === 'Saving...') $btn.text('Save');
            }
        });
    });

    $(document).on('click', '.custom-tab', function () {
        $('.custom-tab').removeClass('active');
        $(this).addClass('active')
        $('.custom-tab-content').hide();
        $('#' + $(this).data('tab')).fadeIn();
        localStorage.setItem('current_tab', $(this).data('tab'));
        // dynamicAttribute($(this).data('tab'));
    });
    let current_tab = localStorage.getItem('current_tab');

    if (current_tab && $('#' + current_tab).length > 0) {
        $('.custom-tab-content').hide();
        $('#' + current_tab).fadeIn();
        $('.custom-tab').removeClass('active');
        $('.' + current_tab).addClass('active')
        // dynamicAttribute(current_tab);
    } else {
        $('.custom-tab-content').hide();
        $('.custom-tab').removeClass('active');
        $('#basicTab').fadeIn();
        $('.basicTab').addClass('active')

    }

    // function dynamicAttribute(current_tab) {
    //     if (current_tab == 'seoTab') {
    //         $('.descHelp').attr('required', true);
    //     } else {
    //         $('.descHelp').attr('required', false);
    //     }
    //     if (current_tab == 'basicTab') {
    //         $('input[name="address"]').attr('required', true);
    //         $('input[name="city"]').attr('required', true);
    //         $('input[name="state"]').attr('required', true);
    //         $('input[name="zip_code"]').attr('required', true);
    //     } else {
    //         $('input[name="address"]').attr('required', false);
    //         $('input[name="city"]').attr('required', false);
    //         $('input[name="state"]').attr('required', false);
    //         $('input[name="zip_code"]').attr('required', false);
    //     }
    // }
    // dynamicAttribute('basicTab');

    if ($('#reportTabContent').length > 0 || $('#progressTabContent').length > 0) {
        $('#progressTabContent').html("<p class='text-center'>Loading Please wait ...</p>");
        $('#reportTabContent').html("<p class='text-center'>Loading Please wait ...</p>");
    }

    function progressTabContent() {
        $.ajax({
            url: baseUrl + '/progress-report',
            data: { 'business_id': $('#business_id').val(), 'method': 'ajax' },
            type: 'post',
            beforeSend: function () {
                $('#progressTabContent').html('<div class="spinner-border report-spinner-border  mt-5" role="status"><span class="sr-only">Loading...</span></div>');
            },
            success: function (res) {
                if (res.status != 0) {
                    $('#progressTabContent').html(res);
                    $('#note').hide();
                } else {
                    $('#note').show();
                    const alert = res.message || "Something went wrong please try again later";
                    $('#progressTabContent').html("<div class='alert alert-warning alert-dismissible'>" + alert + "</div>");
                }
                // $(".spinner-border").fadeOut();
                // $("#overlay").fadeOut();
            },
            error: function () {
                $('#progressTabContent').html("<div class='text-center'>Something went wrong please try again later</div>");
                // $(".spinner-border").fadeOut();
                // $("#overlay").fadeOut();
            }
        })
    }

    $(document).ready(function () {
        if ($('#progressTabContent').length > 0) {
            progressTabContent();
        }
    })

    function reportTabContent() {
        $.ajax({
            url: baseUrl + '/baseline-report',
            data: { 'business_id': $('#business_id').val(), 'method': 'ajax' },
            type: 'post',
            beforeSend: function () {
                $('#reportTabContent').html('<div class="spinner-border report-spinner-border mt-5" role="status"><span class="sr-only">Loading...</span></div>');
            },
            success: function (res) {
                $('#reportTabContent').html(res);
                // $(".spinner-border").fadeOut();
                // $("#overlay").fadeOut();
            },
            error: function () {
                $('#reportTabContent').html("<div class='text-center'>Something went wrong please try again later</div>");
                // $(".spinner-border").fadeOut();
                // $("#overlay").fadeOut();
            }
        })
    }

    $(document).ready(function () {
        if ($('#reportTabContent').length > 0) {
            reportTabContent();
        }
    })

    $(document).on('click', '#refreshProgressReport', function () {
        progressTabContent();
    });

    $(document).on('click', '#refreshBaselineReport', function () {
        reportTabContent();
    });

    // $(document).on('click','.reportPdf',function () {
    //     var doc = new jsPDF();
    //     doc.internal.scaleFactor = 5;
    //     doc.addHTML($('#reportPdf')[0], 15, 15, {
    //       'background': '#fff',
    //       pagesplit: true
    //     }, function() {
    //       doc.save('sample-file.pdf');
    //     });
    // });

    if ($('#heading_select2').length > 0) {
        $('#heading_select2').on('change', function () {
            let gcid_name = $('#smart_gcid_selected').find(":selected").text();
            if (gcid_name) {
                $('#hdn_gcid_name').val(gcid_name);
            } else if ($('#heading_select2').select2('data')[0]) {
                gcid_name = $('#heading_select2').select2('data')[0].gcid_name;
                $('#hdn_gcid_name').val(gcid_name);
            }
            else {
                $('#hdn_gcid_name').val('');
            }
        });

        $('#smart_gcid_selected').on('change', function () {
            let gcid_name = $('#smart_gcid_selected').find(":selected").text();
            if (gcid_name) {
                $('#hdn_gcid_name').val(gcid_name);
            } else if ($('#heading_select2').select2('data')[0]) {
                gcid_name = $('#heading_select2').select2('data')[0].gcid_name;
                $('#hdn_gcid_name').val(gcid_name);
            } else {
                $('#hdn_gcid_name').val('');
            }
        });
    }

    $(document).on('click', '.cancel-order', function (e) {
        e.preventDefault();
        Swal.fire({
            icon: 'error',
            title: 'Do you want to cancel this order?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: `No`,
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.href = $(this).data('href');
            } else if (result.isDenied) {
                Swal.fire('Changes are not saved', '', 'info')
            }
        });
    });

    if ($('.rm-cover-img').length > 0) {
        $(document).on('click', '.rm-cover-img', function (e) {
            e.preventDefault();
            let businessId = $(this).data('bid');
            Swal.fire({
                icon: 'error',
                title: 'Are you sure! You want to remove cover image?',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                denyButtonText: `No`,
            }).then((result) => {
                if (result.isConfirmed) {
                    $.ajax({
                        url: baseUrl + '/remove-cover',
                        type: 'POST',
                        data: { 'business_id': businessId },
                        success: function (res) {
                            $('.cover-img-tag').fadeOut();
                            Swal.fire(res.msg, '', 'success');
                            $('.trusted-notice').removeClass('d-none');
                        },
                        error:function(res){
                            Swal.fire(res.responseJSON.msg, '', 'error')
                        }
                    })
                } else if (result.isDenied) {
                }
            });
        });
    }

    const tabSwitchOnInvalid = (tab) => {
        if (localStorage.getItem('current_tab') != tab) {
            if (tab && $('#' + tab).length > 0) {
                $('.custom-tab-content').hide();
                $('#' + tab).fadeIn();
                $('.custom-tab').removeClass('active');
                $('.' + tab).addClass('active')
                localStorage.setItem('current_tab', tab);
            }
        }
    }
    window.tabSwitchOnInvalid = tabSwitchOnInvalid;
});

export default YthBusiness;
